import React from "react"

import ControlButtonStandard from "../../../../../buttons/control-button/control-button-standard"
import {LexicalEditor} from "lexical"

type Props = {
    menuParams: {
        options         : any[]
        editor          : LexicalEditor
        codeLanguage    : string
    }
    hidePopover : callback
}

export default function ToolbarCodeLanguageButton(state: any, props: Props) {
    const {codeLanguage, options} = props.menuParams

    let option: any
    _.some(options, o=>{
        if (o.options) {
            option = _.find(o.options, option=>option.value === codeLanguage)
        } else if (o.value === codeLanguage) {
            option = o
        }

        return !!option
    })

    const label = option ? option.label : 'Unknown'

    const classes = Classes("flex-row-center-center p-l-8 p-r-8", {
        'show-popover': state.showPopover
    })

    return (
        <ControlButtonStandard className={classes}>
            <div className="ui5-txt-not-important-small lh-16 no-wrap m-r-5">{label}</div>
            <div className="ui5-triangle-toggle s6 open m-t-3"/>
        </ControlButtonStandard>
    )
}